module.exports = __webpack_public_path__ + "img/009.e6a14ecb.png";